import { PowerSupplyPictogram } from '@packages/shared/src/ui/PowerSupplyPictogram/PowerSupplyPictogram';

export type PowerSupplyProps = {
  maxPower: number;
  minPower: number;
  chargerType: 'Normal' | 'PowerDelivery';
  powerSupplyIncluded: 'included' | 'notIncluded';
  asCard?: boolean;
  powerSupplyMessage: string;
  showPowerSupplyMessage?: boolean;
};

export const PowerSupply = ({
  maxPower,
  minPower,
  chargerType,
  powerSupplyIncluded,
  asCard = false,
  powerSupplyMessage,
  showPowerSupplyMessage = false,
  ...rest
}: PowerSupplyProps) => (
  <div
    {...rest}
    className={`flex ${asCard ? 'flex-row' : 'flex-col'} flex-nowrap gap-0.5 ${asCard && 'border-color-grey items-center gap-1 rounded-[8px] border p-1.5'}`}
  >
    {showPowerSupplyMessage && (
      <div className={`text-size-body3 ${asCard ? 'order-2' : 'order-1'}`}>
        {powerSupplyMessage}
      </div>
    )}
    <div className={`flex flex-row gap-1 ${asCard ? 'order-1' : 'order-2'} `}>
      <PowerSupplyPictogram
        layout={powerSupplyIncluded === 'included' ? 'Included' : 'NotIncluded'}
        imageAlt={powerSupplyMessage}
      />
      <PowerSupplyPictogram
        layout="Specification"
        chargerType={chargerType}
        maxPower={maxPower}
        minPower={minPower}
      />
    </div>
  </div>
);
